module.exports = "/images/sk.svg?7a7e24879d51691b7ac4beb53de3a242";